import { createAsyncThunk } from "@reduxjs/toolkit";
import setBaseURL from "../libs/utilities/helpers/BaseURLHelper";
import { api } from "./config/axiosConfig";

const getAPIConfig = (serviceId) => {
    if (!serviceId) return null;
    const envVarName = `REACT_APP_BASE_URL_GPT`;
    // const envVarName = `REACT_APP_BASE_URL_${page.toUpperCase().replace(/-/g, "_")}`;
    const apiPath =serviceId;
    return {
        baseURL: process.env[envVarName], 
        pdflist: `/gpt/${apiPath}/list`,
        uploadpdf: `/gpt/${apiPath}/upload`,
        removePdf:`/gpt/${apiPath}/delete`
    };
};

export class UploadFolderModalAPI {
    getPdfList = createAsyncThunk(
        "",
        async ({ serviceId }) => {
            try {
                const { baseURL, pdflist } = getAPIConfig(serviceId);
                setBaseURL(api, baseURL);
                const response = await api.post(`${pdflist}`, {});
                // const filteredData = response.data.data.map(obj => ({
                //     ...obj,
                //     file: obj.file.filter(fileObj => fileObj.embedded !== false)
                // }));  
                //console.log(response.data.data,"response.data.data");
                              
                const filteredData = response.data.data.data.map(obj => ({
                    ...obj,
                    file: obj.file.filter(fileObj => fileObj.embedded != false)
                }));                
                // return filteredData;
                return {
                    filteredData,
                    suggestionList: response.data.data.suggestions,
                    departmentList:response.data.data.departments
                  };
                // return response.data;
            } catch (error) {
                throw error;
            }
        }
    );

    getPdf = createAsyncThunk(
        "",
        async ({ serviceId, ...data }) => {
            try {
                const { baseURL, pdflist } = getAPIConfig(serviceId);
                setBaseURL(api, baseURL);
                const response = await api.post(`/document/gpt/list/${data.fileName}`, { folder_name: data.folderName });
                return response.data;
            } catch (error) {
                throw error;
            }
        }
    );


    uploadPdf = createAsyncThunk(
        "",
        async ({ serviceId, ...data }, { rejectWithValue }) => {
            try {
                const { baseURL, uploadpdf } = getAPIConfig(serviceId);
                setBaseURL(api, baseURL);
                const response = await api.post(`${uploadpdf}`, data, {
                    headers: {
                        "Content-Type": `multipart/form-data; boundary=${data._boundary}`,
                    },
                });
                return response.data;
            } catch (error) {
                return rejectWithValue(error.response.data);
            }
        }
    )

    
 removePdf = createAsyncThunk(
    "",
    async ({ serviceId, ...data }, { rejectWithValue }) => {
        //console.log(serviceId,"nsjnsns",data);
        try {            
            const { baseURL, removePdf } = getAPIConfig(serviceId);
            setBaseURL(api, baseURL);
            const response = await api.post(`${removePdf}`, data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
}
